const REASON_TYPE = {
  DELIVERY_DELAYED: 1,
  GUIDELINE: 2,
  SICKNESS: 3,
  ETC: 9,
};

const RENTAL_POSTING_DUE = {
  REASON_TYPE,
};

export default RENTAL_POSTING_DUE;
